@if (paginator) {
  <ui-molecule-paginator
    [showClearFiltersButton]="showClearFiltersButton"
    [showExportButton]="showExportButton"
    [exportLabelKey]="exportLabelKey"
    [exportTooltipKey]="exportTooltipKey"
    [showGlobalSearch]="showGlobalSearch"
    (clearFiltersClick)="clearFilters()"
    (exportClick)="exportToExcel()"
    (globalSearch)="onGlobalSearch($event)"
    [length]="paginationMode === 'server' ? totalItems : dataSource.data.length || 0"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    (pageChange)="onInternalPageChange($event)"
  >
    <ng-content></ng-content>
  </ui-molecule-paginator>
}

<div class="ui-molecule-mat-table--main-container" [class.is-loading]="isLoading">
  @if (isLoading) {
    <mat-progress-bar
      mode="indeterminate"
      class="ui-molecule-mat-table--progress"
    ></mat-progress-bar>
  }

  <mat-table
    [dataSource]="dataSource"
    matSort
    [matSortDisabled]="false"
    class="ui-molecule-mat-table--style"
  >
    @for (column of columns; track column) {
      <ng-container [matColumnDef]="column.key">
        <mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          [style.width]="column.width"
          [style.min-width]="column.width"
          [style.max-width]="column.width"
        >
          <div class="ui-molecule-mat-table--header">
            {{ column.titleKey ? (column.titleKey | translate) : column.title }}
          </div>
        </mat-header-cell>

        <mat-cell
          *matCellDef="let element"
          [style.width]="column.width"
          [style.min-width]="column.width"
          [style.max-width]="column.width"
        >
          @switch (column.type) {
            @case ('date') {
              <span>{{ getNestedValue(element, column.key) | date: 'MM/dd/yyyy' }}</span>
            }
            @case ('phone') {
              <span>{{ getNestedValue(element, column.key) | formatPhone }}</span>
            }
            @case ('email') {
              <span
                class="email-cell"
                [matTooltip]="getNestedValue(element, column.key)"
                [matTooltipShowDelay]="200"
              >
                {{ getNestedValue(element, column.key) }}
              </span>
            }
            @case ('custom') {
              <span>{{
                column.getValue ? column.getValue(element) : getNestedValue(element, column.key)
              }}</span>
            }
            @case ('status-chip') {
              @if (column.getStatus) {
                <ui-atom-status-chip
                  [label]="column.getStatus(element).label"
                  [variant]="column.getStatus(element).variant"
                />
              }
            }
            @case ('icon-action') {
              @if (!column.showIcon || column.showIcon(element)) {
                <ui-atom-button-icon
                  (click)="$event.stopPropagation(); onActionClick(column.key, element)"
                  [icon]="column.icon || ''"
                  [matTooltip]="column.iconTooltipKey ? (column.iconTooltipKey | translate) : (column.titleKey ? (column.titleKey | translate) : column.title)"
                  [matTooltipShowDelay]="tooltipShowDelay"
                />
              }
            }
            @case ('copy-text') {
              <span
                class="ui-molecule-mat-table--copy-cell"
                (click)="$event.stopPropagation(); onCopyClick(getNestedValue(element, column.key))"
                [matTooltip]="
                  column.iconTooltipKey
                    ? (column.iconTooltipKey | translate: { value: getNestedValue(element, column.key) })
                    : (column.titleKey ? (column.titleKey | translate) : column.title)
                "
                matTooltipClass="ui-tooltip-multiline"
                [matTooltipShowDelay]="tooltipShowDelay"
              >
                {{ getNestedValue(element, column.key) }}
              </span>
            }
            @default {
              <span>
                {{
                  column.mapping
                    ? column.mapping[getNestedValue(element, column.key)] ||
                      getNestedValue(element, column.key)
                    : getNestedValue(element, column.key)
                }}
              </span>
            }
          }
        </mat-cell>
      </ng-container>
    }
    @if (actions.length > 0) {
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>
          {{ actionsColumnTitle ? actionsColumnTitle : (actionsColumnTitleKey | translate) }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          @for (action of actions; track action) {
            @if (!action.showIf || action.showIf(element)) {
              <ui-atom-button-icon
                (click)="
                  $event.stopPropagation();
                  !action.disabledIf?.(element) && onActionClick(action.event, element)
                "
                [icon]="action.icon"
                [fontSet]="action.iconFontSet || ''"
                [disabled]="action.disabledIf ? action.disabledIf(element) : false"
                [comingSoon]="action.comingSoon || false"
                [matTooltip]="
                  action.tooltipKey ? (action.tooltipKey | translate) : action.tooltip
                "
                [matTooltipShowDelay]="tooltipShowDelay"
              />
            }
          }
        </mat-cell>
      </ng-container>
    }

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row (click)="onRowClick(row)" *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>

  @if (isLoading && dataSource.data.length === 0) {
    <div class="ui-molecule-mat-table--initial-loading">
      <ui-molecule-spinner [color]="spinnerColor" />
    </div>
  }
</div>
